/*
 *  Desktop Menu
 *
 *  Version:
 *    1.0.0 - 2019/07/31
 */
 import { t } from '@process-creative/slate-theme-tools';
 import Cookies from 'js-cookie';
 import { fetchRecentlyViewed } from '../../sections/recently-viewed/RecentlyViewed';

export const DESKTOP_MENU_SELECTOR = '[data-desktop-menu]';
export const DESKTOP_MENU_SUBMENU = '[data-desktop-menu-submenu]';
export const DESKTOP_MENU_LINK = '[data-desktop-menu-link]';
export const DESKTOP_SUBSUBMENU_LINK = '[data-desktop-menu-subsubmenu-link]';
export const DESKTOP_SUBMENU_IMAGE = '[data-submenu-image]';
export const HEADER_CONTAINER_SELECTOR = '[data-header-container]';

export const DESKTOP_MENU_SEARCH_TOGGLE = '[data-search-toggle]';
export const DESKTOP_MENU_SEARCH_INPUT = '[data-search-input]';

const DESKTOP_MENU_SUBSUBMENU_CONTAINER = '[data-desktop-menu-subsubmenu-container]';
const DESKTOP_MENU_SUBSUBMENU_WRAP = '[data-desktop-menu-subsubmenu-wrap]';

const RECENTLY_VIEWED_URL = 'data-recently-viewed-url';
const RECENTLY_VIEWED_IMAGE = 'data-recently-viewed-image';

//Attrs
export const DESKTOP_MENU_LINK_IMAGE = 'data-link-image';
const ATTR_BD_HOVER_IMAGE = 'data-bd-link-image';
const ATTR_KAS_HOVER_IMAGE = 'data-kas-link-image';

export const CLASS_VISIBLE = 'is-visible';
export const CLASS_VISIBLE_RECENTLY_VIEWED = 'is-recently-viewed';
export const CLASS_OPEN = 'is-menu-open';
export const CLASS_ACTIVE= 'is-active';
const CLASS_BEN_DAVID_TAB = 'ben-david-tab';

export class DesktopMenu {
  constructor(container, parent) {
    this.container = container;
    this.parent = parent;

    //Elements
    this.submenuImage = container.find(DESKTOP_SUBMENU_IMAGE);
    this.headerContainer = $(HEADER_CONTAINER_SELECTOR);
    this.menuLink = container.find(DESKTOP_MENU_LINK);
    this.subSubmenuContainer = container.find(DESKTOP_MENU_SUBSUBMENU_CONTAINER);
    this.recentlyViewedURL = container.attr(RECENTLY_VIEWED_URL);
    this.recentlyViewedImageURL = container.attr(RECENTLY_VIEWED_IMAGE);
    this.isBenDavidTab = document.body.classList.contains(CLASS_BEN_DAVID_TAB);

    //Events
    container.on('mouseenter', DESKTOP_MENU_LINK, e => this.onHoverLink(e));
    container.on('mouseleave', DESKTOP_MENU_LINK, e => this.onUnhoverLink(e));
    container.on('mouseenter', DESKTOP_MENU_SUBMENU, e => this.onHoverMenu(e));
    container.on('mouseleave', DESKTOP_MENU_SUBMENU, e => this.onUnhoverMenu(e));
    container.on('mouseenter', DESKTOP_SUBSUBMENU_LINK, e => this.onHoverLinkSub(e));
    parent.on('click', DESKTOP_MENU_SEARCH_TOGGLE, e => this.searchToggle(e));
    // $(document).on('mouseenter', '[data-desktop-menu-link-recently-viewed]', e => this.onHoverLinkSub(e));

    //add recently viewed link if the user has viewed product
    if (this.recentlyViewedURL) this.addRecentlyViewedLink();

  }

  onHoverLink(e){
    let self = $(e.currentTarget);
    let img = self.attr(DESKTOP_MENU_LINK_IMAGE);

    if (this.isBenDavidTab) {
      img = self.attr(ATTR_BD_HOVER_IMAGE);
    } else {
      const kasLinkImg = self.attr(ATTR_KAS_HOVER_IMAGE);
      if (kasLinkImg) {
        img = kasLinkImg;
      }
    }

    if(img) {
      this.submenuImage.addClass(CLASS_VISIBLE);
      //if hover on recently viewed
      if (self.closest('.c-desktop-menu__submenu-item').hasClass(CLASS_VISIBLE_RECENTLY_VIEWED)){
        this.submenuImage.addClass(CLASS_VISIBLE_RECENTLY_VIEWED);
      } else {
        this.submenuImage.removeClass(CLASS_VISIBLE_RECENTLY_VIEWED);
      }
      this.submenuImage.html(`<img src="${img}" class="c-desktop-menu__submenu-image is-hover-image">`);
    }
  }

  onUnhoverLink(e){
    this.submenuImage.removeClass(CLASS_VISIBLE); //Hide image
  }

  onHoverLinkSub(e) {
    let self = $(e.currentTarget);
    let group = self.attr('data-group');
    let title = self.attr('data-title');
    this.subSubmenuContainer.closest(DESKTOP_MENU_SUBSUBMENU_WRAP).removeClass(CLASS_ACTIVE);
    this.subSubmenuContainer.removeClass(CLASS_ACTIVE);
    this.subSubmenuContainer.each( (_, el) => {
      if ($(el).attr('data-group') != group || $(el).attr('data-title') != title) return;
      $(el).addClass(CLASS_ACTIVE);
      $(el).closest(DESKTOP_MENU_SUBSUBMENU_WRAP).addClass(CLASS_ACTIVE);
    });
    this.menuLink.removeClass(CLASS_ACTIVE);
    if (group == undefined || title == undefined) return;
    self.addClass(CLASS_ACTIVE);
  }

  onHoverMenu(e) {
    this.headerContainer.addClass(CLASS_OPEN);
  }

  onUnhoverMenu(e) {
    this.headerContainer.removeClass(CLASS_OPEN);
  }

  addRecentlyViewedLink() {
    try {
      let existing = Cookies.getJSON('recent-product-views');
      if(existing && existing.length) {
        fetchRecentlyViewed()
          .then(e => this.onRecentlyViewedMenuImageonHover(e,existing))
      }
    } catch (error) {
      console.error(`Failed to fetch recently viewed!`+ex)
    }
  }

  
  //change image on menu link 
  onRecentlyViewedMenuImageonHover(data, IDs){
    let lastViewed = data.find(e => (e.id.toString() === IDs[0].toString()));
    if (lastViewed) this.recentlyViewedImageURL = lastViewed.image;

    let html = 
    `<li class="c-desktop-menu__item is-recently-viewed ">\
        <a href="${this.recentlyViewedURL}" 
        class="c-desktop-menu__item-link" 
        data-desktop-menu-link
        data-desktop-menu-link-recently-viewed
        data-link-image="${this.recentlyViewedImageURL}"
        title="${t('layout.header.recently_viewed')}"
        data-title="${t('layout.header.recently_viewed')}"
        data-group
      >
      ${t('layout.header.recently_viewed')}</a>
      </li>`;

    //append the link at the last of the menu 
    this.headerContainer.find('.c-desktop-menu__menu:not(.is-additional)').append(html);
  }


  searchToggle(e){
    $('html').toggleClass('show-search');
    // If search is visible
    if ($('html').hasClass('show-search')) {
      // Focus after animation
      setTimeout( () => $(DESKTOP_MENU_SEARCH_INPUT).focus(), 200);
    };
  }
}
